import Customer from 'src/models/customer.js';

class PolicyHolder {
  constructor(params) {
    this.customer = new Customer(params.customer);
    this.policies = params.policies;

    return this;
  }
}
export { PolicyHolder as default };
